import { type Dispatch, createContext, useReducer, useContext, useEffect } from 'react'

export const RefreshContext = createContext<Date | undefined>(undefined)
export const RefreshDispatchContext =
        createContext<Dispatch<{
          type: string
        }>>(() => null)

export function useRefresh (): Date | undefined {
  return useContext(RefreshContext)
}

export function useRefreshDispatch (): Dispatch<{
  type: string
}> {
  return useContext(RefreshDispatchContext)
}
export function RefreshProvider (props: { children: JSX.Element }): JSX.Element {
  const [refreshTime, dispatch] = useReducer(refreshReducer, initialAccount)
  useEffect(() => {
    dispatch({ type: 'refresh' })
  }, [])

  return (
    <RefreshContext.Provider value={refreshTime}>
      <RefreshDispatchContext.Provider value={dispatch}>
        {props.children}
      </RefreshDispatchContext.Provider>
    </RefreshContext.Provider>
  )
}
function refreshReducer (refreshTime: Date | undefined, action: { type: string }): Date | undefined {
  switch (action.type) {
    case 'refresh': {
      return new Date()
    }
    default: {
      throw Error('Unknown action: ' + action.type)
    }
  }
}

const initialAccount = undefined
